export default __webpack_public_path__ + "static/blogThumbnail(3)-21818cda6b6cb7631110b5b233bff22a.png";